export const deviceType = {
    VDU: 0, // Tsunami VDU
    G2: 1, // G2
    VDU21: 2, // VDU 2.1
    FT: 3, // Fleet Tracker (e.g. Calamp)
    VDU3: 4, // VDU 3.0 (HW used with Android as OS)
    LT: 5,
    WT: 6, // Walker Tag
    FT2: 7, // FT+, aka ProDrive
    VDU4: 8, // VDU 4.0
};